import { MessageType } from './MessageType';

export const ResolutionType = {
  YES: 'yes',
  NO: 'no',
} as const;

export const ResolutionMessageList = [
  MessageType.RESOLUTION,
  MessageType.ANY_OTHER_HELP_RESOLUTION,
  MessageType.METADATA_RESOLUTION,
  MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION,
] as const;

export type ResolutionKind = typeof ResolutionType[keyof typeof ResolutionType];
export type ResolutionMessageType = typeof ResolutionMessageList[number];
